import { useMutation } from "react-query";
import paths from "API/paths";
import axiosInstance from "Services/axiosConfig";

interface DeleteTreatmentPayloadP {
  projectId: string;
  featureId: string;
  treatmentId: string;
}

const deleteTreatments = async (payload: DeleteTreatmentPayloadP) => {
  try {
    const url = paths.deleteTreatments();
    const response = await axiosInstance.post(url, { input: payload });
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const useDeleteTreatments = () => {
  return useMutation(deleteTreatments);
};
